import React from 'react';
import CompanyLogo from 'assets/images/companylogo.png';
import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class PremiumFormView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingAnimRegister: false,
      userInput: {
        email: '',
      },
    };

    document.body.classList.add('no-scroll');
    this.changeHandler = this.changeHandler.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  changeHandler(event) {
    const input = this.state.userInput;
    input[event.target.name] = event.target.value;
    this.setState({ userInput: input });
  }

  async submitForm(e) {
    e.preventDefault();
    this.setState({ loadingAnimRegister: true });
    setTimeout(() => {
      this.setState({ loadingAnimRegister: false });
    }, 3000);

    if (this.state.userInput.email === '') {
      // Popup error message
      this.setState({ loadingAnimRegister: false });
      toast.error('Please fill in all fields (email)'), {
        position: 'top-center',
        transition: Zoom,
        autoClose: 10000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      };
      return;
    }

    const data = new FormData();
    data.append('email', this.state.userInput.email);
    data.append('form-name', 'premium-form');

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(data).toString(),
    })
      .then(() => {
        toast.success('You have successfully registered for the paid version of TheSource, we’ll let you know when it launches.'), {
          position: 'top-center',
          transition: Zoom,
          autoClose: 10000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        };
        window.setTimeout(() => {
          localStorage.setItem('registerSuccessful', true);
          window.location.href = '/';
        }, 5000);
      })
      .catch(error => alert(error));
  }

  render() {
    const { loadingAnimRegister } = this.state;

    return (
      <div className="loginView">
        <div className="loginView__bg">
          <div className="loginView__bg--content">
            <img src={CompanyLogo} alt="Company Logo" />
            <h3>{i18n.translate('loginScreen.title')}</h3>
          </div>
        </div>
        <div className="premiumForm__content">
          <h1>TheSOURCE<span /></h1>
          <p>
      Thank you sincerely for your interest in TheSOURCE, and we equally appreciate your right to supreme privacy. This initial FREE version requires users to opt-in to communication from the sponsoring destinations and suppliers to unlock training and sales resources. If you would like to wait for the paid version next year, please fill in your information below, and we’ll let you know when it launches.
          </p>
          <form data-netlify="true">
            <input type="hidden" name="form-name" value="premium-form" />.
            <input
              type="email"
              name="email"
              onChange={this.changeHandler}
              placeholder="Email"
            />
            <div className="buttonWrapper">
              <button type="button" onClick={() => window.history.back()} className="whiteExit">Back</button>
              <button type="submit" onClick={this.submitForm}>
                {loadingAnimRegister ? <span><FontAwesomeIcon icon={['fas', 'circle-notch']} spin /></span> : 'Submit'}
              </button>
            </div>
          </form>
          <ToastContainer
            draggablePercent={60}
            autoClose={false}
            newestOnTop
            rtl={false}
            pauseOnVisibilityChange
            draggable
          />
        </div>
      </div>);
  }
}
